module.exports = __webpack_public_path__ + "74b3ea1834685ed68c7561dcc6e0d080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/guitar-button.png
// module id = 39
// module chunks = 0